const defaultEl = {
  id: null,
  title: {},
  link: {},
  order: ''
};

export default {
  name: 'InfoEditRegulation',
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.regulations.edit');
      }
      return this.$t('menu.regulations.new');
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        const tmpEl = this.BasicHelper.cloneObject(elData);
        tmpEl.title = (tmpEl.title === null) ? {} : tmpEl.title;
        tmpEl.link = (tmpEl.link === null) ? {} : tmpEl.link;
        this.editEl = tmpEl;
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$refs['modal-window'].show();
    },
    save () {
      if (!this.loading) {
        this.loading = true;
        const reqData = this.BasicHelper.cloneObject(this.editEl);
        const self = this;
        this.ApiRequest.request('info/regulations/edit', this.ApiRequest.REQUEST_POST, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
